module.exports = __webpack_public_path__ + "img/logo_navbar.b14b8c1f.png";